import { Show } from "solid-js";
import { coinIcon } from "~/assets/assets";
import { goBack, openModalV2 } from "~/shared_states/modal";
import { CoinsTransactionsModalTelescope } from "../../coins_transactions_modal_telescope";
import { useWebStoreContext } from "~/context/webstore_context";
import { enableSingleBrandHomepage } from "~/data/partner_config";

export type BalancePillProps = {
  balance: number;
  showRedeemButton: boolean;
  onRedeemClick: () => void;
};

export function BalancePill(props: BalancePillProps) {
  const formatBalance = (amount: number) => {
    return `${amount.toLocaleString("en-IN")}`;
  };

  const { storeState, refreshV4HomePage, getClientId } = useWebStoreContext();

  function onBalancePillClick() {
    const isSingleBrand =
      storeState.brands?.length === 1 &&
      enableSingleBrandHomepage(getClientId());
    const singleBrandName = isSingleBrand
      ? storeState.brands[0].voucherProduct.title
      : undefined;

    openModalV2(
      () => (
        <CoinsTransactionsModalTelescope
          balance={storeState.coins ?? 0}
          userName={storeState.v4HomePage?.user?.firstName ?? ""}
          refreshV4HomePage={refreshV4HomePage}
          enableRedeemCode={props.showRedeemButton}
          singleBrandName={singleBrandName}
          onClose={() => {
            goBack();
          }}
        />
      ),
      {
        expandToFullHeight: true,
      }
    );
  }

  return (
    <div class="flex h-8 items-center rounded-full border border-stroke-2 bg-background-normal-primary py-[6px] pl-2 pr-0">
      {/* Inner content with gap-[6px] */}
      <button class="flex items-center" onClick={onBalancePillClick}>
        <span class="mx-[6px] hidden whitespace-nowrap text-para-3-medium leading-5 text-text-normal-secondary sm:block">
          Balance
        </span>
        {/* Coin Icon - 20x20 */}
        <img src={coinIcon} alt="coin" class="h-5 w-5" />
        <div class="ml-[6px]"></div>
        <span class="whitespace-nowrap text-para-3-medium leading-5 text-text-normal-primary">
          {formatBalance(props.balance)}
        </span>
      </button>
      <Show
        fallback={<div class="ml-[14px]"></div>}
        when={props.showRedeemButton}
      >
        <div class="ml-[6px]"></div>

        {/* Add Button Container with gap-[10px] and p-[6px] */}
        <div class="flex items-center  px-[6px]">
          <button
            class="flex h-5 w-5 shrink-0 items-center justify-center rounded-full bg-background-inverted-primary"
            onClick={props.onRedeemClick}
          >
            <svg
              width="16"
              height="16"
              viewBox="0 0 16 16"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M8 3.33333V12.6667M3.33333 8H12.6667"
                class="stroke-text-inverted-primary"
                stroke-width="1.33"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
          </button>
        </div>
      </Show>
    </div>
  );
}
